import React from "react";
import { Link } from "react-router-dom";
import "./AboutSection.css";
import { FaGlobeAmericas } from "react-icons/fa";


// 🔹 Import images from assets
import img1 from "../assets/img1.png";
import img2 from "../assets/img2.png";

export default function AboutSection() {
  return (
    <section className="about-section">
      <div className="about-container">
        {/* Left Side - Images */}
        {/* Left Side - Images */}
        <div className="about-images">
          <div className="main-img">
            <img src={img1} alt="Main" />

            {/* Years Experience Box */}
            <div className="exp-box">
              <h2>7+</h2>
              <p>
                Global partner across countries.
                <span className="globe-icon"><FaGlobeAmericas /></span>
              </p>
            </div>

            {/* Small Image */}
            <div className="small-img">
              <img src={img2} alt="Team" />
            </div>

            {/* Call Box */}
            <div className="call-box">
              <span className="icon">📞</span>
              <p>CALL TO EXPERTS</p>
              <p><a href="tel:08169405098"> 08169405098</a></p>
            </div>
          </div>
        </div>


        {/* Right Side - Content */}
        <div className="about-content">
          <h2 className="heading">From Niche Supplier to Global Printing Ally</h2>
          <p>
            Founded in 2019, Recla has grown into a trusted global printing and services company. We’ve supplied businesses across 7+ countries, helping them cut costs and access reliable printing solutions.
          </p>
         
          <p><b>Recla is a subsidiary of Rcube Recycling Pvt. Ltd.</b>, operating as its global printing solutions arm.
         </p>
          <p>
            Now, we’ve brought our expertise to Nigeria, with one goal:
            To save your money while providing top-quality printing supplies and unmatched service.<br></br><br></br>
          </p>

          <Link to="/contact" className="about-btn">
            Contact Us
          </Link>
        </div>
      </div>
    </section>
  );
}
